import {ChangeDetectionStrategy, Component} from "@angular/core";
import {FUIAbstractDomComponent} from "../../framework/abstract-dom";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-switch-dom",
    styleUrls: ["./switch-dom.component.scss"],
    templateUrl: "./switch-dom.component.html"
})
export class FUISwitchDomComponent extends FUIAbstractDomComponent {

}
